"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * @typedef {Object} Notification
 * @property {string} content the main content of the notification
 * @property {Eids} eids
 * @property {string} priority the severity/importance of the notification
 * @property {string} subcategory describes the nature of the notification
 * @property {Action[]} actions available actions
 */

/**
 * @typedef {Object} Eids
 * @property {type} click
 */

/**
 * @typedef {Object} Action
 * @property {string} link href linking to the associated action
 */

/**
 * Get the notifications array from `sessionStorage`
 * @returns {Notification[]} An array containing the available notifications, if any is found.
 */
function notifications() {
  return typeof window !== 'undefined' && window.sessionStorage && window.sessionStorage.getItem('GD_MYA_Notifications') || [];
}

var _default = notifications;
exports["default"] = _default;